import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Main from './Main';
import QRScanner from './components/QRScanner';
import QRScannerClass from './components/QRScannerClass';
import BlockList from './components/BlockList';
import ClassList from './components/ClassList';
import ClassStudents from './components/ClassStudents';
import ClassTranscript from './components/ClassTranscript';
import Student from './components/Student';
import ParentView from './components/ParentView';
import CatechistProfile from './components/CatechistProfile';
import Login from './Login';
import AddNewStudent from './admin/AddNewStudent';
import { StudentProvider } from './StudentContext';
import AdminManagement from './admin/AdminManagement';
import PrintCards from './admin/PrintCards';
import EarlyAttendanceStats from './admin/EarlyAttendanceStats';
import CatechistManager from './admin/CatechistManager';
import DisciplineBoard from './admin/DisciplineBoard';

function App() {
  return (
    <StudentProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin-management" element={<AdminManagement />}>
            <Route index element={<Navigate to="print-cards" replace />} />
            <Route path="print-cards" element={<PrintCards />} />
            <Route path="early-attendance" element={<EarlyAttendanceStats />} />
            <Route path="catechist-management" element={<CatechistManager />} />
            <Route path="add-new-student" element={<AddNewStudent />} />
          </Route>
          <Route path="/discipline-board" element={<DisciplineBoard />}>
            <Route index element={<Navigate to="early-attendance" replace />} />
            <Route path="early-attendance" element={<EarlyAttendanceStats />} />
          </Route>
          <Route path="/main" element={<Main />}>
            <Route path="qr-scanner" element={<QRScanner />} />
            <Route path="qr-scanner-class" element={<QRScannerClass />} />
            <Route path="class-list" element={<BlockList />}>
              <Route path=":blockId" element={<ClassList />}>
                <Route path=":classId" element={<ClassStudents />} />
              </Route>
            </Route>
            <Route path="class-transcript/:blockId/:classId" element={<ClassTranscript />} />
            <Route path="student/:studentId" element={<Student />} />
            <Route path="profile" element={<CatechistProfile />} />
            <Route index element={<Navigate to="qr-scanner" replace />} />
          </Route>
          <Route path="/parent" element={<ParentView />} />
          <Route path="/parent/student/:studentId" element={<Student />} />
          <Route path="/" element={<Navigate to="/main" replace />} />
        </Routes>
      </Router>
    </StudentProvider>
  );
}

export default App;